module.exports = __webpack_public_path__ + "static/Planning-d3d4425bd9bbf7fedc6d5c463eec04a7.png";